import { IDashboard as IBEDashboard } from "fieldpro-tools/dist/src/types/dashboards";
import { ISupersetDashboard } from "fieldpro-tools/src/types";

import { IDashboard } from "model/entities/Dashboard";
import { IAction, IActionError, IBeginAction } from "redux/store/model";

import * as types from "./actionTypes";
export interface ICreateDashboardSuccessAction extends IAction {
  dashboard: IDashboard;
}
export interface IUpdateDashboardSuccessAction extends IAction {
  dashboard: IDashboard;
}
export interface IMovearchivedDashboardsToDefaultFolderSuccessAction
  extends IAction {
  folderArchivedDashboardIds: string[];
}
export interface IDeleteDashboardSuccessAction extends IAction {
  id: string;
}
export interface IArchiveDashboardsSuccessAction extends IAction {
  ids: string[];
}
export interface IRestoreDashboardsSuccessAction extends IAction {
  ids: string[];
}
export interface IFetchDashboardsSuccessAction extends IAction {
  dashboards: IBEDashboard[];
}

export interface IFetchFrequentlyViewedDashboardsSuccessAction extends IAction {
  dashboardIds: string[];
}
export interface IComputeDashboardSuccessAction extends IAction {
  dashboardId: string;
  // eslint-disable-next-line no-warning-comments -- legacy comment, to review
  kpis: any[]; // FIXME replace "any" with a more precise type
  query: any;
  raw_data?: any;
  superset_dashboard_guest_token?: string;
  superset_dashboard_uuid?: string;
}
export interface IComputeKpiSuccessAction extends IAction {
  // eslint-disable-next-line no-warning-comments -- legacy comment, to review
  kpi: any; // FIXME replace "any" with a more precise type
  query: any;
  raw_data?: any;
}
export type IClearDashboardDataSuccessAction = IAction;
export interface IChangeSubcategorySuccessAction extends IAction {
  subcategory: string;
}

/**
 * Create dashboard begin action creator
 * This creates an action informing redux store that the creation process for a dashboard has just began
 * @returns {Object}
 */
export function createDashboardBeginActionCreator(): IBeginAction {
  return {
    type: types.CREATE_DASHBOARD_BEGIN,
  };
}

/**
 * Failure Action for creating a dashboard instructing that the creation process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function createDashboardFailureActionCreator(error: any): IActionError {
  return {
    type: types.CREATE_DASHBOARD_FAILURE,
    error,
  };
}

/**
 * Success action for creating a dashboard
 * @param {Object} dashboard Dashboard object,
 * @returns {Object}
 */
export const createDashboardSuccessActionCreator = (
  dashboard: IDashboard,
): ICreateDashboardSuccessAction => {
  return {
    type: types.CREATE_DASHBOARD_SUCCESS,
    dashboard,
  };
};

/**
 * Edit dashboard begin action creator
 * This creates an action informing redux store that the creation process for a dashboard has just began
 * @returns {Object}
 */
export function updateDashboardBeginActionCreator(): IBeginAction {
  return {
    type: types.UPDATE_DASHBOARD_BEGIN,
  };
}

/**
 * Failure Action for editing a dashboard instructing that the edition process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function updateDashboardFailureActionCreator(error: any): IActionError {
  return {
    type: types.UPDATE_DASHBOARD_FAILURE,
    error,
  };
}

/**
 * Success action for editing a dashboard
 * @param {Object} dashboard Dashboard object,
 * @returns {Object}
 */
export function updateDashboardSuccessActionCreator(
  dashboard: IDashboard,
): IUpdateDashboardSuccessAction {
  return {
    type: types.UPDATE_DASHBOARD_SUCCESS,
    dashboard,
  };
}
/**
 * Success action for editing a dashboard
 * @param {Object} dashboard Dashboard object,
 * @returns {Object}
 */
export function moveArchivedDashboardsToDefaultFolderSuccessActionCreator(
  dashboardIds: string[],
): IMovearchivedDashboardsToDefaultFolderSuccessAction {
  return {
    type: types.MOVE_ARCHIVED_DASHBOARDS_TO_DEFAULT_FOLDER_SUCCESS,
    folderArchivedDashboardIds: dashboardIds,
  };
}

/**
 * Delete dashboard begin action creator
 * This creates an action informing redux store that the creation process for a dashboard has just began
 * @returns {Object}
 */
export function deleteDashboardBeginActionCreator(): IBeginAction {
  return {
    type: types.DELETE_DASHBOARD_BEGIN,
  };
}

/**
 * Failure Action for creating a dashboard instructing that the creation process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function deleteDashboardFailureActionCreator(error: any): IActionError {
  return {
    type: types.DELETE_DASHBOARD_FAILURE,
    error,
  };
}

/**
 * Success action for creating a dashboard
 * @param {Object} dashboardId Dashboard object,
 * @returns {Object}
 */
export function deleteDashboardSuccessActionCreator(
  dashboardId: string,
): IDeleteDashboardSuccessAction {
  return {
    type: types.DELETE_DASHBOARD_SUCCESS,
    id: dashboardId,
  };
}

/**
 * Archive dashboard begin action creator
 * This creates an action informing redux store that the archive process for a dashboard has just began
 * @returns {Object}
 */
export function archiveDashboardsBeginActionCreator(): IBeginAction {
  return {
    type: types.ARCHIVE_DASHBOARDS_BEGIN,
  };
}

/**
 * Failure Action for creating a dashboard instructing that the archive process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function archiveDashboardsFailureActionCreator(
  error: any,
): IActionError {
  return {
    type: types.ARCHIVE_DASHBOARDS_FAILURE,
    error,
  };
}

/**
 * Success action for archiving dashboards
 * @param {Array} dashboardIds Dashboard ids to archive,
 * @returns {Object}
 */
export function archiveDashboardsSuccessActionCreator(
  dashboardIds: string[],
): IArchiveDashboardsSuccessAction {
  return {
    type: types.ARCHIVE_DASHBOARDS_SUCCESS,
    ids: dashboardIds,
  };
}

/**
 * Restore dashboard begin action creator
 * This creates an action informing redux store that the restore process for a dashboard has just began
 * @returns {Object}
 */
export function restoreDashboardsBeginActionCreator(): IBeginAction {
  return {
    type: types.RESTORE_DASHBOARDS_BEGIN,
  };
}

/**
 * Failure Action for creating a dashboard instructing that the restore process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function restoreDashboardsFailureActionCreator(
  error: any,
): IActionError {
  return {
    type: types.RESTORE_DASHBOARDS_FAILURE,
    error,
  };
}

/**
 * Success action for restoring dashboards
 * @param {Array} dashboardIds Dashboard ids to restore,
 * @returns {Object}
 */
export function restoreDashboardsSuccessActionCreator(
  dashboardIds: string[],
): IArchiveDashboardsSuccessAction {
  return {
    type: types.RESTORE_DASHBOARDS_SUCCESS,
    ids: dashboardIds,
  };
}
/**
 * begin action when there is a request to fetch all dashboards
 * @returns {Object}
 * */
export const fetchAllDashboardsBeginActionCreator = (): IBeginAction => ({
  type: types.FETCH_ALL_DASHBOARDS_BEGIN,
});

/**
 * Failure action for fetching all dashboards. This action is dispatched when there is an error fetching all
 * dashboards
 * @param {Object} error
 * @returns {Object}
 * */
export const fetchAllDashboardsFailureActionCreator = (
  error: any,
): IActionError => ({
  type: types.FETCH_ALL_DASHBOARDS_FAILURE,
  error,
});

/**
 * Fetch all Dashboards action creator
 * @param {Array} dashboards an array of dashboard objects
 * @returns {Object}
 * */
export const fetchAllDashboardsSuccessActionCreator = (
  dashboards: IBEDashboard[],
): IFetchDashboardsSuccessAction => ({
  type: types.FETCH_ALL_DASHBOARDS_SUCCESS,
  dashboards,
});

/**
 * Process dashboard begin action process
 * This process an action informing redux store that the  process for a dashboard has just began
 * @returns {Object}
 */
export function computeDashboardBeginActionCreator(): IBeginAction {
  return {
    type: types.COMPUTE_DASHBOARD_BEGIN,
  };
}

/**
 * Failure Action for processind a dashboard instructing that the run  process for a dashboard has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function computeDashboardFailureActionCreator(error: any): IActionError {
  return {
    type: types.COMPUTE_DASHBOARD_FAILURE,
    error,
  };
}

/**
 * Success action for processing a dashboard
 * @param {Object} kpis kpis data,
 * @returns {Object}
 */
export function computeDashboardSuccessActionCreator(
  kpis: any[],
  dashboardId: string,
  query: any,
  raw_data: any,
  superset_dashboard_guest_token?: string,
  superset_dashboard_uuid?: string,
): IComputeDashboardSuccessAction {
  return {
    type: types.COMPUTE_DASHBOARD_SUCCESS,
    kpis,
    dashboardId,
    query,
    raw_data,
    superset_dashboard_guest_token,
    superset_dashboard_uuid,
  };
}

/**
 * Process kpi begin action process
 * This process an action informing redux store that the  process for a kpi has just began
 * @returns {Object}
 */
export function computeKpiBeginActionCreator(): IBeginAction {
  return {
    type: types.COMPUTE_KPI_BEGIN,
  };
}

/**
 * Failure Action for processing a kpi instructing that the run  process for a kpi has failed
 * @param {Object} error Error Object
 * @returns {Object}
 */
export function computeKpiFailureActionCreator(error: any, kpid?: string) {
  return {
    type: types.COMPUTE_KPI_FAILURE,
    error,
    kpid: kpid,
  };
}

/**
 * Success action for processing a dashboard
 * @param {Object} kpis kpis data,
 * @returns {Object}
 */
export function computeKpiSuccessActionCreator(
  kpi: any,
  query: any,
  raw_data: any,
): IComputeKpiSuccessAction {
  return {
    type: types.COMPUTE_KPI_SUCCESS,
    kpi,
    query,
    raw_data,
  };
}

/**
 * creates a clear data action
 * @returns {Object}
 */
export function clearDashboardDataAction(): IClearDashboardDataSuccessAction {
  return {
    type: types.CLEAR_DATA,
  };
}

/**
 * begin action when there is a request to fetch all dashboards
 * @returns {Object}
 * */
export const fetchAllSupersetDashboardsBeginActionCreator =
  (): IBeginAction => ({
    type: types.FETCH_ALL_SUPERSET_DASHBOARDS_BEGIN,
  });

/**
 * Failure action for fetching all superset dashboards. This action is dispatched when there is an error fetching all
 * superset dashboards
 * @param {Object} error
 * @returns {Object}
 * */
export const fetchAllSupersetDashboardsFailureActionCreator = (
  error: any,
): IActionError => ({
  type: types.FETCH_ALL_SUPERSET_DASHBOARDS_FAILURE,
  error,
});

/**
 * Fetch all Superset Dashboards action creator
 * @param {Array} dashboards an array of dashboard objects
 * @returns {Object}
 * */
export const fetchAllSupersetDashboardsSuccessActionCreator = (
  supersetDashboards: ISupersetDashboard[],
): IFetchSupersetDashboardsSuccessAction => ({
  type: types.FETCH_ALL_SUPERSET_DASHBOARDS_SUCCESS,
  supersetDashboards,
});
export interface IFetchSupersetDashboardsSuccessAction extends IAction {
  supersetDashboards: ISupersetDashboard[];
}

/*
 * Frequently viewed dashboards Action creators
 */
export const fetchFrequentlyViewedDashboardsBeginActionCreator =
  (): IBeginAction => ({
    type: types.FETCH_FREQUENTLY_VIEWED_DASHBOARDS_BEGIN,
  });

export const fetchFrequentlyViewedDashboardsFailureActionCreator = (
  error: any,
): IActionError => ({
  type: types.FETCH_FREQUENTLY_VIEWED_DASHBOARDS_FAILURE,
  error,
});

export const fetchFrequentlyViewedDashboardsSuccessActionCreator = (
  dashboardIds: string[],
): IFetchFrequentlyViewedDashboardsSuccessAction => ({
  type: types.FETCH_FREQUENTLY_VIEWED_DASHBOARDS_SUCCESS,
  dashboardIds,
});
